// ============================================================================
// 9'One Store — Centralized Store Configuration
// ----------------------------------------------------------------------------
// Single source of truth for all business info. Edit values here and they
// update everywhere across the site. Do NOT duplicate this data in components.
// ============================================================================

export const storeConfig = {
  storeName: "9'One Store",
  brandShort: "9'One",
  domain: "9onestore.com",
  tagline: "Premium Streetwear & Essential Tees",

  // --- Address ---
  address: "Plot No. 40, Industrial Area, Kiratpur",
  city: "Itarsi",
  state: "Madhya Pradesh",
  pincode: "461111",
  country: "India",
  get fullAddress() {
    return `${this.storeName}, ${this.address}, ${this.city} – ${this.pincode}, ${this.state}, ${this.country}`;
  },

  // --- Primary contact (also the WhatsApp / order number) ---
  primaryContactName: "Akash Kalosiya",
  primaryPhone: "9039122348",
  primaryPhoneIntl: "+91 9039122348",
  primaryEmail: "Akash.kalosiya88@gmail.com",

  // --- Secondary contact ---
  secondaryContactName: "Vikas Verma",
  secondaryPhone: "9424471999",
  secondaryPhoneIntl: "+91 9424471999",
  secondaryEmail: "vikash.gati786@gmail.com",

  // --- WhatsApp order number (digits only, with country code, no +) ---
  whatsappNumber: "919039122348",

  // --- Social (configure when available) ---
  instagramUrl: "https://www.instagram.com/9onestore7",
  instagramHandle: "@9onestore7",
  facebookUrl: "https://www.facebook.com/share/1DJVnxMQji/",

  // --- Currency ---
  currency: "INR",
  currencySymbol: "₹",
  locale: "en-IN",

  // --- Announcement bar ---
  announcementEnabled: true,
  announcementText: "New Collection Coming Soon",

  // --- Promo codes (Phase 1: local only, easy to disable) ---
  promoEnabled: true,
  promoCodes: {
    // code: { type: "percent" | "flat", value: number, label: string }
    WELCOME10: { type: "percent", value: 10, label: "10% off your order" },
  },
};

// Helpers ---------------------------------------------------------------------

export const mapsDirectionsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  storeConfig.fullAddress
)}`;

export const mapsEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(
  storeConfig.fullAddress
)}&output=embed`;

export const telHref = (phone) => `tel:+91${phone.replace(/\D/g, "")}`;
export const mailtoHref = (email) => `mailto:${email}`;

export default storeConfig;
